import { css, Theme } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const PopupNoteVBOSStyle = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    margin-left: 32px;
    margin-right: 32px;
    padding-bottom: 32px;

    .thumbnail {
      width: 120px;
      height: 120px;
      margin: 10px auto;

      img {
        width: 100%;
        height: 100%;
      }

      ${media.md} {
        width: 100%;
      }
    }

    .title-provider {
      font-size: 16px;
      text-align: center;
      margin-bottom: 10px;
      font-weight: 700;
      color: ${theme.colors.lightText};
    }

    .balance {
      border-top: 1px solid ${theme.borders.primary};
      border-bottom: 1px solid ${theme.borders.primary};
      padding: 5px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 60%;
      margin: 0 auto;

      ${media.md} {
        width: 100%;
      }

      span {
        font-size: 14px;
        font-weight: 500;
        color: ${theme.colors.lightText};

        &.amount {
          font-weight: 700;
          font-size: 18px;
          color: ${theme.colors.darkGreen};
        }
      }

      .ant-skeleton {
        width: auto;
      }
    }
  `,
  buttonSubmit: ({ colors }: Theme) => css`
    height: 44px;
    background: ${colors.gradient[1]} !important;
    border-radius: 8px;
    border: 0px;
    margin-top: 24px;
    color: ${colors.text.buttonActive} !important;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    cursor: pointer;
  `,
};
